import './style/index.less';
import UserPanel from './UserPanel';

export default UserPanel;
